import { Box } from '@mui/material'
import { LiveClassScheduleResponse } from '../types'
import { DayColumn } from './DayColumn'

interface ScheduleGridProps {
  scheduleData: LiveClassScheduleResponse
}

export let ScheduleGrid = ({ scheduleData }: ScheduleGridProps) => {
  // Filter to only show Monday-Friday (weekdays)
  let weekdays = scheduleData.days.filter((day) => {
    let dayName = day.dayName.toLowerCase()
    return ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'].includes(
      dayName,
    )
  })

  return (
    <Box
      component="section"
      aria-labelledby="page-title"
      role="region"
      aria-label="Weekly live class schedule"
      className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-4"
    >
      {weekdays.map((day) => (
        <DayColumn key={day.date} day={day} />
      ))}
    </Box>
  )
}
